import React from "react";
import {
  Box, Paper, Stack, Skeleton, alpha, useTheme
} from "@mui/material";

const ClientsScreenSkeleton = () => {
  const theme = useTheme();

  const renderSkeletonItems = () => {
    return Array.from({ length: 5 }).map((_, index) => (
      <Box
        key={index}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          p: 2,
          borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        }}
      >
        <Skeleton variant="circular" width={40} height={40} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="60%" height={24} />
          <Skeleton variant="text" width="40%" height={20} />
        </Box>
        <Skeleton variant="rectangular" width={80} height={30} sx={{ borderRadius: 1 }} />
      </Box>
    ));
  };

  return (
    <Box sx={{ 
      display: "flex", flexDirection: "column", height: "100vh", p: 1.5, gap: 1.5, 
      background: theme.palette.background.default, maxWidth: '100vw', overflow: 'hidden' 
    }}>
      <Paper elevation={0} sx={{ p: 1.5, borderRadius: 2, border: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Skeleton variant="text" width={150} height={32} />
            <Skeleton variant="rounded" width={60} height={20} />
          </Stack>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2 }}>
            <Skeleton variant="rounded" width={180} height={36} />
            <Skeleton variant="rounded" width={180} height={36} />
            <Skeleton variant="circular" width={36} height={36} />
            <Skeleton variant="circular" width={36} height={36} />
            <Skeleton variant="circular" width={36} height={36} />
            <Skeleton variant="rounded" width={100} height={36} />
          </Box>
        </Box>
      </Paper>

      <Paper elevation={0} sx={{ flexGrow: 1, overflow: 'hidden', borderRadius: 2, border: `1px solid ${alpha(theme.palette.divider, 0.1)}`, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ p: 1, px: 2, borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
          <Skeleton variant="text" width={150} height={20} />
        </Box>
        <Box sx={{ flexGrow: 1, overflow: 'auto', width: '100%', p: 1 }}>
          {renderSkeletonItems()}
        </Box>
        <Box sx={{ p: 1.5, borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`, display: 'flex', justifyContent: 'center' }}>
          <Skeleton variant="rounded" width={300} height={32} />
        </Box>
      </Paper>
    </Box>
  );
};

export default ClientsScreenSkeleton;